import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const DiaUkraineButton = withStyles({
  root: {
    background: '#175E82',
    borderRadius: '600px',
    border: 0,
    color: 'white',
    height: 48,
    padding: '20px 40px',
    gap: '10px',
    '&:hover': {
      background: '#2594cc',
      boxShadow: '0 3px 5px 2px rgb(37,148,204)',
    },
  },
  label: {
    textTransform: 'capitalize',
  },
})(Button);

export default DiaUkraineButton;


